/**
 * @fileoverview Segmentation / Tabs component
 *
 * It creates a functional tabs with panels component
 */

import BaseComponent from '../BaseComponent';

const NAME = 'DigitalMediaServiceNavbar';

const DATA_KEY = 'lta.digitalMediaServiceNavbar';
const EVENT_KEY = `.${DATA_KEY}`;
//  const DATA_API_KEY = '.data-api';

//  const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`;

//  const SELECTOR_DATA_TOGGLE = '[data-lta-tabs]';

class DigitalMediaServiceNavbar extends BaseComponent {
    constructor(element) {
        super(element);

        this.init();
    }

    static get NAME() {
        return NAME;
    }

    // Getters
    static get DATA_KEY() {
        return DATA_KEY;
    }

    dispose() {
        super.dispose()
        // Remove event handlers, reset constructor public settings etc.
    }

    init() {
        const navigationItems = this._element.querySelectorAll('li');
        navigationItems.forEach(nav => {
            nav.addEventListener('click', (e) => {
                navigationItems.forEach(i => {
                    if(i != nav) {
                        i.classList.remove('active');
                    } else {
                        i.classList.contains('active') ? i.classList.remove('active') : i.classList.add('active');
                    }
                })
            });
        })
    }
}

export default DigitalMediaServiceNavbar;
